export default {"src":"/_next/static/media/arrow-float-button.048d370f.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};